module.exports = __webpack_public_path__ + "static/media/thumbnail.4d72217f.jpg";